import React, { useState, useEffect } from "react";
import { Modal, Button, Carousel } from "react-bootstrap";
import WhatsNew from "../assets/carousels/WhatsNew.png";
import firstImage from "../assets/carousels/firstImage.png";
import ContentTesting from "../assets/carousels/ContentTesting.png";
import MusicCharts from "../assets/carousels/MusicCharts.png";
import MusicAlerts from "../assets/carousels/MusicAlerts.png";
import Any_questions from "../assets/carousels/Any_questions.png";

export default function CarouselModal() {
    const marketingData = [
        {
            title: "NEW FEATURES AT RADIOANALYZER PRO",
            description: (
                <>
                    Let us take you on a tour! Just click through this slideshow. If you have any questions reach out at{" "}
                    <a className="text-dark fw-bold " href="mailto:support@radioanalyzer.com" target="_blank" rel="noreferrer">
                        support@radioanalyzer.com
                    </a>
                </>
            ),

            image: firstImage,
        },
        {
            title: "Decades Graph ",
            description:
                "See at a glance how old or young any song list is. Get a detailed breakdown of the age composition by library, or by spins. Available in Music Charts for Stations or Markets, and in  Competitor Charts. ",
            image: MusicCharts,
        },
        {
            title: "Music Alerts Update ",
            description:
                "More granular music alerts to stay of top of changes in station’s libraries. Choose to receive alerts for only newly released songs or all newly added oldies and recurrents to stay up-to-date on how your competition is changing their library. ",
            image: MusicAlerts,
        },
        {
            title: "Content Testing Filtering",
            description:
                "Filter your Talk results based on categories or keyword. A simple, flexible, search and filter function that will automatically calculate average scores and durations on the fly and compare them with your overall performance.",
            image: ContentTesting,
        },
        {
            title: "ANY QUESTIONS?",
            description: (
                <>
                    Need help navigating or have a technical question? We are happy to hear from you at{" "}
                    <a className="text-dark fw-bold " href="mailto:support@radioanalyzer.com" target="_blank" rel="noreferrer">
                        support@radioanalyzer.com
                    </a>
                </>
            ),
            image: Any_questions,
        },
    ];

    const [show, setShow] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleSelect = selectedIndex => {
        setCurrentIndex(selectedIndex);
    };
    useEffect(() => {
        const hideForever = localStorage.getItem("hideNewCarouselModal");
        if (!hideForever) {
            setShow(true);
        }
    }, []);

    const handleCloseOnlyThisTime = () => {
        setShow(false);
    };

    const handleCloseForever = () => {
        localStorage.setItem("hideNewCarouselModal", "true");
        setShow(false);
    };

    return (
        <>
            <Modal show={show} onHide={handleCloseOnlyThisTime} size="xl" centered>
                <Modal.Body className="modal-carousel-body ">
                    <Carousel variant="dark" interval={null} controls indicators activeIndex={currentIndex} onSelect={handleSelect}>
                        {marketingData.map((item, index) => (
                            <Carousel.Item key={index}>
                                {item.image && <img src={item.image} alt={item.title} style={{ maxHeight: "60vh", width: "100%", objectFit: "cover" }} />}
                            </Carousel.Item>
                        ))}
                    </Carousel>
                    {/* Text below the carousel */}
                    {marketingData.length > 0 && (
                        <div className="text-center modal-text-container mt-3">
                            <h3 className="text-uppercase">{marketingData[currentIndex].title}</h3>
                            <span>{marketingData[currentIndex].description}</span>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="">
                    <Button variant="secondary" onClick={handleCloseOnlyThisTime}>
                        Close only this time
                    </Button>
                    <Button variant="danger" onClick={handleCloseForever}>
                        Close forever
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
